import { useSelector } from "react-redux";
import { useAppDispatch } from "hooks/hooks";
import Modal from "components/Modal/Modal";
import { toast } from "react-toastify";

import {
  deletePartner,
  removePartner,
  selectPartnerForDeletion,
  selectState,
  setIndexForDeletion,
} from "../main.slice";

const DeletePartnerModal = () => {
  const { deletePartnerModalOpen } = useSelector(selectState);
  const partner = useSelector(selectPartnerForDeletion);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setIndexForDeletion(-1));
  };

  const doDelete = async () => {
    try {
      await dispatch(deletePartner(partner.partnerId));
      dispatch(removePartner(partner.partnerId));
      toast.success("Uspesno obrisan.");
      close();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal
      isOpen={deletePartnerModalOpen}
      onClick={doDelete}
      onClose={close}
      title="Brisanje partnera"
    >
      <p className="info-msg">
        Da li ste sigurni da želite da obrišete sledećeg partnera:
        <br />
        <br />
        <b>{partner?.shortName} ?</b>
      </p>
    </Modal>
  );
};

export default DeletePartnerModal;
